import Check from '@material-ui/icons/Check';
import Cross from '@material-ui/icons/Clear';
import * as React from 'react';
export default {
  Check,
  Cross,
  React
};